import React, { useRef } from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import { MAIN_HEADER_HEIGHT } from '../../../../../theme'
import Loading from '../../../../molecules/Loading'
import ChatMessages from './ChatMessages'
import MessageInput from './MessageInput'

const useStyles = makeStyles(() => ({
  chatPanel: {
    borderLeft: 'var(--border-neutral-thin)',
    background: 'linear-gradient(var(--color-neutral-200), var(--color-neutral-300))',
    position: 'relative',
    height: '100%',
    maxHeight: `calc(100vh - ${MAIN_HEADER_HEIGHT + 12}px)`,
    display: 'flex',
    flexDirection: 'column'
  },
  chatInput: {
    width: '100%'
  },
  textInput: {
    backgroundColor: 'var(--color-neutral-400)',
    border: 'none',
    borderRadius: 'var(--border-radius-md)',
    outline: 'none',
    width: '100%',
    fontFamily: 'var(--font-sans)',
    padding: 'var(--padding-sm)'
  },
  chatMessage: {
    whiteSpace: 'pre'
  }
}))

function ChatPanel ({ messages, onNewMessage, onJsxAttachmentClick, isLoading }) {
  const classes = useStyles()
  const inputRef = useRef(null)

  if (isLoading) {
    return (
      <div className={classes.chatPanel}>
        <Loading />
      </div>
    )
  }

  return (
    <div className={classes.chatPanel}>
      <ChatMessages messages={messages} onJsxAttachmentClick={onJsxAttachmentClick} />
      <div className={classes.chatInput}>
        <div className='relative w-full p-xs'>
          <MessageInput ref={inputRef} placeholder='Describe your idea' onSend={onNewMessage} />
        </div>
      </div>
    </div>
  )
}

ChatPanel.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape({
    threadId: PropTypes.string,
    threadMessageId: PropTypes.string,
    actor: PropTypes.oneOf(['agent', 'user']),
    message: PropTypes.string,
    data: PropTypes.object,
    isGenerating: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    generationStatus: PropTypes.string,
    responseId: PropTypes.string
  })).isRequired,
  onNewMessage: PropTypes.func.isRequired,
  onJsxAttachmentClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
}

export default ChatPanel
